<div class="modal">
    <div class="header">
        <h1 translate [translateParams]="{email: memberToAttach.username}" *ngIf="memberToAttach?.username" class="title">
            PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_GROUP_TITLE</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(attachGroupProcessing$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class="section">
                <!-- <h2 class="title-section" translate>PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_GROUP_SUBTITLE_GROUP</h2> -->
                <form class="form-section" [formGroup]="attachGroupForm" (ngSubmit)='onSubmit()'>
                    <div class="form-input">
                        <ng-select [items]="attributableGroups" bindLabel="name" [searchable]="false" [clearable]="false"
                            placeholder="{{ 'PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_GROUP_PLACEHOLDER_GROUP' | translate }}" formControlName="group"
                            [(ngModel)]="selectedGroup">
                        </ng-select>
                    </div>
                </form>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" (click)="closeModal()" [disabled]="(attachGroupProcessing$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="onSubmit()" [disabled]="!f.group.value || (attachGroupProcessing$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_GROUP_BUTTON_LABEL_ADD_GROUP</button>
    </div>
</div>